/**
 * Как появилась строка записи (ТЗ главной § 13, § 22.4, § 22.7): новая запись сверху въезжает по высоте
 * (`grow`), строки, которые открыло «Показать ещё» (или нажатие сигнала по записи за пятёркой), проявляются
 * вместе одной прозрачностью (`fade`); первая отрисовка — без анимации (`null`). Решает позиция, а не только
 * «был ли id в списке»: догруженная страница и новый лимит могут прийти в одном рендере, и строки новой
 * страницы тогда въезжали бы каждая по высоте. Чистая функция без alias-импортов.
 *
 * `known` — id записей прошлого рендера (null — первого рендера ещё не было), `previousLimit` — окно
 * прошлого рендера.
 */
export function rowEnter(
  known: ReadonlySet<string> | null,
  id: string,
  index: number,
  previousLimit: number,
): 'grow' | 'fade' | null {
  if (known === null) return null;
  if (known.has(id) || index >= previousLimit) return 'fade';
  return 'grow';
}
